import { useAtom } from 'jotai';
import { currentPageAtom } from 'global/store';
import { Box } from '@xstyled/styled-components';
import Button from '@/UI/Button';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { useTranslation } from 'next-i18next';

export default function Pagination({ pages }) {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useAtom(currentPageAtom);
  const pageNumbers = getPages(currentPage, pages);

  const paginate = page => {
    setCurrentPage(page);
    //window.scrollTo({ top: 0, behavior: 'smooth' });
    var position = getOffset(document.getElementById('product_container'))
  
    
    const scrollPos = { x: 0, y: position.top };

    
    window.scrollTo({ top: scrollPos.y, behavior: 'smooth' });
   
    sessionStorage.setItem('pagination_change', JSON.stringify(scrollPos));

    function getOffset(el) {
      const rect = el.getBoundingClientRect();
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      };
    }

  };

  return (
    <FlexBox align="center" alignSelf="center" mt={42}>
      {pages > 1 && (
        <NavigationButton
          text={t('previous')}
          inactive={currentPage === 1}
          onClick={() => paginate(currentPage - 1)}
        />
      )}

      <FlexBox spaceX={4}>
        {pageNumbers.map(page => {
          return (
            <Box
              key={page}
              as="span"
              role="button"
              onClick={() => page !== '...' && paginate(page)}
              aria-label={`Paginate to page ${page}`}
              p="4px 12px"
              border={currentPage === page ? '1px solid #45AAC4' : 'none'}
              borderRadius={3}
              color="#343434"
              cursor={
                currentPage === page || page === '...' ? 'auto' : 'pointer'
              }
            >
              {page}
            </Box>
          );
        })}
      </FlexBox>

      {pages > 1 && (
        <NavigationButton
        text={t('next')} 
                 inactive={currentPage === pageNumbers.slice(-1)[0]}
          onClick={() => paginate(currentPage + 1)}
        />
      )}
    </FlexBox>
  );
}

const NavigationButton = ({ onClick, text, inactive }) => {
  return (
    <Button
      as="span"
      role="button"
      aria-label={`Navigate to ${text}`}
      onClick={onClick}
      pointerEvents={inactive ? 'none' : 'auto'}
      fontSize={{ _: '0.875rem', desktop: '1rem' }}
      color={inactive ? '#BABABA' : '#343434'}
      hoverOpacity={inactive ? 1 : 0.75}
    >
      <Box as="span" mr={6}>
        {text === 'Eelmine' || text ==='Previous' && '<'}
      </Box>
      {text}
      <Box as="span" ml={6}>
        {text === 'Järgmine' || text === 'Next' && '>'}
      </Box>
    </Button>
  );
};

const getPages = (currentPage, pageCount) => {
  const delta = 2;

  let range = [];

  for (
    let i = Math.max(2, currentPage - delta);
    i <= Math.min(pageCount - 1, currentPage + delta);
    i += 1
  ) {
    range.push(i);
  }

  if (currentPage - delta > 2) {
    range.unshift('...');
  }

  if (currentPage + delta < pageCount - 1) {
    range.push('...');
  }

  range.unshift(1);

  if (pageCount !== 1) range.push(pageCount);

  return range;
};
